import alt from 'components/Dispatcher';
import {Store, StoreMethods} from '@store/@types/alt';
import {FetchUserTableResponse, UserTableView} from '@store/@types/UserAdmin';
import {List} from 'immutable';
import AdminUserActions, {AdminUserActionsInterface} from '@store/admin/AdminUserActions';
import {Int} from '@store/@types/util';

interface AdminUserStoreState {
  users: List<UserTableView>;
  usersLoading: boolean;
  total: Int;
}

class AdminUserStore
  extends Store<AdminUserStoreState>
  implements StoreMethods<AdminUserActionsInterface>
{
  constructor() {
    super();
    this.state = {
      users: List(),
      usersLoading: true,
      total: 0,
    };
    this.bindActions(AdminUserActions);
  }

  // Only used in AdminRouter.tsx to prevent table from showing stale data
  setLoading(): void {
    this.setState({usersLoading: true});
  }

  fetchUserTable(): void {
    this.setState({usersLoading: true});
  }
  fetchUserTableError(error: Error): void {
    console.error(error);
    this.setState({usersLoading: false});
  }
  fetchUserTableSuccess({total, users}: FetchUserTableResponse): void {
    this.setState({
      total,
      users,
      usersLoading: false,
    });
  }

  setUserActive(): void {}
  setUserActiveError(error: Error): void {
    console.error(error);
  }
  setUserActiveSuccess(args: any): void {}

  setUserTeam(): void {}
  setUserTeamError(error: Error): void {
    console.error(error);
  }
  setUserTeamSuccess(args: any): void {}
}

export default alt.createStore(AdminUserStore);
